import type { MouseEvent } from 'react'
import { dispatchDeskNavigation, type DeskViewMode } from '@/msgdeskRuntime/deskNavigation'
import { legacyContractDataAttrs } from '@/msgdeskRuntime/legacyBridge/SelectorContracts'
import { useDeskMenu } from '@/deskUiSkeletons/Menu/menuModel'

const entries: ReadonlyArray<{ mode: DeskViewMode; label: string }> = [
  { mode: 'msg', label: 'Portal' },
  { mode: 'answers', label: 'Answers' },
  { mode: 'submsges', label: 'Messages' },
]

export function PortalMenu() {
  const menu = useDeskMenu()
  const locked = !menu.access.showUnlocked

  function navigate(event: MouseEvent<HTMLButtonElement>, mode: DeskViewMode) {
    dispatchDeskNavigation({ mode, target: event.currentTarget })
  }

  return (
    <nav
      {...legacyContractDataAttrs('sidebar.root')}
      className={`fixed left-2.5 top-2.5 z-[100000] flex h-11 items-center gap-1 rounded-[14px] border border-slate-200 bg-white/90 p-1 text-sm text-slate-600 shadow-lg backdrop-blur-xl${locked ? ' hidden' : ''}`}
      style={locked ? { display: 'none' } : undefined}
      aria-label="Portal navigation"
    >
      {entries.map(entry => {
        const tab = menu.tabByMode[entry.mode]
        if (!tab.available) return null
        return (
          <button
            key={entry.mode}
            type="button"
            className={`h-9 rounded-[10px] px-3 font-medium transition-colors ${tab.isActive ? 'bg-blue-600 text-white' : 'hover:bg-blue-50 hover:text-blue-700'}`}
            aria-current={tab.isActive ? 'page' : undefined}
            onClick={event => navigate(event, entry.mode)}
          >
            {entry.label}
          </button>
        )
      })}
    </nav>
  )
}
